// extracted by mini-css-extract-plugin
export default {"container":"app-header_container__DJ+JG","box":"app-header_box__YdpE4","linkWhite":"app-header_linkWhite__nlM74","link":"app-header_link__bQOS4","header":"app-header_header__wssg-"};